import { API_ENDPOINTS, API_BASE_URL } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const mediaService = {
  
  uploadMedia: async (file, createdBy, companyId, companyName, onProgress) => {
    try {
      const formData = new FormData();
      formData.append('Files', file);
      formData.append('CreatedBy', createdBy);
      formData.append('CompanyId', companyId);
      formData.append('CompanyName', companyName);

      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        
        xhr.upload.onprogress = (event) => {
          if (event.lengthComputable && onProgress) {
            const percentComplete = Math.round((event.loaded / event.total) * 100);
            onProgress(percentComplete);
          }
        };
        
        xhr.onload = () => {
          if (xhr.status === 200) {
            try {
              const response = JSON.parse(xhr.response);
              resolve(response);
            } catch (e) {
              resolve(xhr.response);
            }
          } else {
            let errorMsg = `Upload failed with status ${xhr.status}`;
            try {
              const errorResponse = JSON.parse(xhr.response);
              errorMsg = errorResponse.message || errorMsg;
            } catch(e) {}
            reject(new Error(errorMsg));
          }
        };
        
        xhr.onerror = () => reject(new Error('Network error during upload'));
        
        const fullUrl = `${API_BASE_URL}${API_ENDPOINTS.UPLOAD_MEDIA}`;
        xhr.open('POST', fullUrl);
        const token = localStorage.getItem('accessToken');
        if (token) {
          xhr.setRequestHeader('Authorization', `Bearer ${token}`);
        }
        xhr.send(formData);
      });
    } catch (error) {
      console.error('Upload media error:', error);
      throw error;
    }
  },

  // Get All Media List
  getAllMedia: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_ALL_MEDIA,
        method: 'POST',
        data: {},
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get all media error:', error);
      throw error;
    }
  },

  // Get Media By Company ID
  getMediaByCompanyId: async (companyId) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_MEDIA_BY_COMPANY_ID,
        method: 'POST',
        data: { companyId },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get media by company ID error:', error);
      throw error;
    }
  },

  // Delete Media File
  deleteMediaFile: async (id, deletedBy) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_MEDIA_FILE,
        method: 'POST',
        data: { id, deletedBy },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete media file error:', error);
      throw error;
    }
  },

  // Update Media File
  updateMediaFile: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_MEDIA_FILE,
        method: 'POST',
        data: {
          Id: data.id,
          FileName: data.fileName,
          OriginalFileName: data.originalFileName,
          File: data.file,
          FileType: data.fileType,
          ContentType: data.contentType,
          FileSize: data.fileSize,
          FilePath: data.filePath,
          CompanyID: data.companyId,
          Duration: data.duration,
          UpdatedBy: data.updatedBy,
        },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Update media file error:', error);
      throw error;
    }
  },
};